import { gql } from '@apollo/client';

export const GET_VOLUNTEER_COMMUNICATIONS = gql`
  query GetVolunteerCommunications($userId: String!) {
    em {
      emails(userId: $userId) {
        ...VolunteerCommonProfileEmail
      }
      outboundSms(userId: $userId) {
        ...VolunteerCommonProfileSms
      }
    }
  }

  fragment VolunteerCommonProfileEmail on EMAIL_PostmarkOutboundEmailType {
    __typename
    postmarkEmailId
    userId
    toEmail
    subject
    sentBy
    sentAt
    tag
    body
    postmarkClicks {
      clickedAt
    }
    postmarkBounce {
      bouncedAt
    }
    postmarkDelivery {
      deliveryAt
    }
    postmarkOpens {
      openedAt
    }
  }

  fragment VolunteerCommonProfileSms on EMAIL_OutboundSmsType {
    __typename
    outboundSmsId
    userId
    messageId
    contactNumber
    body
    sentAt
  }
`;